var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',{attrs:{"to":{ path: _vm.path }}},[_vm._v(_vm._s(_vm.title))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.title)+"详情")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }